import { yup } from '@framework/validation/initYup.ts';

export interface IIntegrableDirective {
  /**
   * Abilita/disabilita la modifica del campo in fase di integrazione.
   * Utilizziamo "disabled" e non "enabled" perché di default tutti i campi sono abilitati.
   */
  disabled?: boolean | null;
}

export const IntegrableDirectiveSchema: yup.ObjectSchema<IIntegrableDirective> =
  yup
    .object({
      disabled: yup
        .boolean()
        .notRequired()
        .transform(value => value ?? false)
        .default(false)
        .label('Disabilitata modifica'),
    })
    .noUnknown();
